import { useContext } from 'react';
import './Loading.scss';
import { Backdrop, CircularProgress } from '@mui/material';
import { DataContext } from '../../context/DataContext';

function Loading() {
  const { loading } = useContext(DataContext);
  return (
    <Backdrop
      sx={{
        color: '#33FFF3',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(216, 244, 246, 0.6)',
      }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Loading;
